// extracted by mini-css-extract-plugin
export default {"button":"qu47YA","link":"QDeDc8","container":"ZsFrsT","mobile-container":"Hoofhl","mobileContainer":"Hoofhl"};